import React from 'react';
import { Row, Col, Button, Badge } from 'reactstrap';
import ModalComponent from '@componentes/modal/modal.component';
import ButtonFloating from '@componentes/button/button-floating.component';
import * as acessos from '../../../../acessos.const.util';
import './macroscopia.styles.css';
import HistoricoLaudoContainer from './tabs/historicolaudo/historico-laudo.container';
import MultiplosExamesContainer from '@common/multiplosExames/multiplosExames.container';
import FrascoContainer from './tabs/frascos/frascos.container';
import AnexoContainer from '@common/tabs/anexo/anexo.container';
import AutoTextoContainer from '@common/tabs/autotexto/autotexto.container';
import LaudosAnterioresContainer from '@common/tabs/anteriores/laudos-anteriores.container';
import CancelamentoComponent from '../../../../componentes/cancelamento/cancelamento.component';
import ConfirmarCancelamento from '../../../../componentes/cancelamento/confirmacao.component';
import IntlMessage from '../../../../helpers/intlMessage';

const MacroscopiaPage = (props) => (
  <div>
    <ConfirmarCancelamento
      isOpen={props.showModalConfirmarCancelamento}
      toggle={props.toggleModalConfirmarCancelamento}
      setJustificativa={props.setJustificativa}
      justificativaCancelar={props.justificativaCancelar}
      shoModalJustificativa={props.showModalConfirmacaoCancelamento}
    />

    <CancelamentoComponent
      isOpen={props.showModalCancelamento}
      toggle={props.toggleModalCancelamento}
      setJustificativa={props.setJustificativa}
      justificativaCancelar={props.justificativaCancelar}
      cancelarEtapa={props.cancelarEtapas}
    />
    <ModalComponent
      noFooter={props.modalNoFooter}
      size="lg"
      visivel={props.modalVisivel}
      titulo={props.modalTitulo}
      style={props.modalStyle}
      cancela={
        props.modalTitulo === 'Salvar alterações'
          ? props.closeModal
          : props.fecharModal
      }
      confirma={
        props.modalTitulo === 'Salvar alterações'
          ? props.confirmaModal
          : undefined
      }
    >
      {props.modalConteudo}
    </ModalComponent>
    <Col
      sm={props.detalhes === undefined ? '0' : undefined}
      className="paddingZero"
    >
      {props.detalhes !== undefined && (
        <div>
          <div style={{ height: '100%' }} className="detalhes-macro-container">
            <div className="inner-menu-container">
              <Row>
                {props.acessoPermitido(props.usuario, acessos.AutoTexto) &&
                  !props.exameFinalizado &&
                  !props.macroscopiaFinalizada && (
                    <Col>
                      <Button
                        className={
                          props.visibilidadeAutotexto
                            ? 'mv-tab-ativo'
                            : undefined
                        }
                        onClick={() =>
                          props.alterarVisibilidadeAbas('visibilidadeAutotexto')
                        }
                        color='link'
                        title='CTRL+ALT+A'
                      >
                        <IntlMessage id="dashboards.examDetails.autoText"/>
                      </Button>
                    </Col>
                  )}
                {props.acessoPermitido(props.usuario, acessos.Anexo) && (
                  <Col>
                    <Button
                      color='link'
                      className={
                        props.visibilidadeListagemAnexo
                          ? 'mv-tab-ativo'
                          : undefined
                      }
                      onClick={() =>
                        props.alterarVisibilidadeAbas(
                          'visibilidadeListagemAnexo'
                        )
                      }
                    >
                      <IntlMessage id="dashboards.examDetails.attachments"/>
                    </Button>
                  </Col>
                )}

                {props.acessoPermitido(
                  props.usuario,
                  acessos.LaudosAnteriores
                ) && (
                  <Col>
                    <Button
                      className={`${
                        props.totalExamesAbertos > 0
                          ? 'alerta-exame-aberto'
                          : props.visibilidadeLaudosAnteriores
                          ? 'mv-tab-ativo'
                          : props.visibilidadeLaudosAnteriores &&
                            props.totalExamesAbertos
                          ? 'mv-tab-ativo alerta-exame-aberto'
                          : ''
                      }`}
                      onClick={() =>
                        props.alterarVisibilidadeAbas(
                          'visibilidadeLaudosAnteriores'
                        )
                      }
                      color='link'
                      title='CTRL+ALT+T'
                    >
                      <IntlMessage id="dashboards.examDetails.previousReports"/>
                      <Badge className='tabs-total-itens'>
                        {props.quantidadeLaudosAnteriores}
                      </Badge>
                    </Button>
                  </Col>
                )}
                {props.acessoPermitido(props.usuario, acessos.ListaFrasco) &&
                  !props.exameFinalizado &&
                  !props.macroscopiaFinalizada && (
                    <Col>
                      <Button
                        className={
                          props.visibilidadeFrascos ? 'mv-tab-ativo' : undefined
                        }
                        onClick={() =>
                          props.alterarVisibilidadeAbas('visibilidadeFrascos')
                        }
                        color='link'
                        title='CTRL+ALT+F'
                      >
                        <IntlMessage id = "dashboards.examDetail.listBlocks"/>
                      </Button>
                    </Col>
                  )}

                {props.acessoPermitido(
                  props.usuario,
                  acessos.HistoricoLaudo
                ) && (
                  <Col>
                    <Button
                      className={
                        props.visibilidadeHistoricoLaudo
                          ? 'mv-tab-ativo'
                          : undefined
                      }
                      onClick={() =>
                        props.alterarVisibilidadeAbas(
                          'visibilidadeHistoricoLaudo'
                        )
                      }
                      color='link'
                      title='CTRL+ALT+H'
                    >
                      <IntlMessage id="dashboards.examDetails.reportHistory"/>
                    </Button>
                  </Col>
                )}
                {props.acessoPermitido(
                  props.usuario,
                  acessos.MultiplosExames
                ) && (
                  <Col>
                    <Button
                      className={
                        props.visibilidadeMultiplosExame
                          ? 'mv-tab-ativo'
                          : undefined
                      }
                      onClick={() =>
                        props.alterarVisibilidadeAbas(
                          'visibilidadeMultiplosExame'
                        )
                      }
                      color='link'
                      title='CTRL+ALT+M'
                    >
                      <IntlMessage id = "dashboards.examDetail.multipleExams"/>
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button
                    onClick={props.incluirInformesClinicosEditor}
                    color="link"
                    title="CTRL+ALT+I"
                  >
                    <IntlMessage id = "dashboards.examDetail.includeClinicalReports"/>
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={props.alterarFullscreen}
                    color="link"
                    title="CTRL+ALT+F10"
                  >
                    <i
                      className={
                        window.document.fullscreen
                          ? 'fas fa-compress'
                          : 'fas fa-expand'
                      }
                    ></i>
                  </Button>
                </Col>
              </Row>
            </div>

            <Row className='mv-tabs-container'>
              {props.visibilidadeAutotexto &&
                props.acessoPermitido(props.usuario, acessos.AutoTexto) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <AutoTextoContainer altura={props.altura} />
                  </Col>
                )}

              {props.visibilidadeFrascos &&
                props.acessoPermitido(props.usuario, acessos.ListaFrasco) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <FrascoContainer altura={props.altura} />
                  </Col>
                )}
              {props.visibilidadeLaudosAnteriores &&
                props.acessoPermitido(
                  props.usuario,
                  acessos.LaudosAnteriores
                ) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <LaudosAnterioresContainer altura={props.altura} />
                  </Col>
                )}

              {props.visibilidadeListagemAnexo &&
                props.acessoPermitido(props.usuario, acessos.Anexo) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <AnexoContainer altura={props.altura} />
                  </Col>
                )}

              {props.visibilidadeHistoricoLaudo &&
                props.acessoPermitido(
                  props.usuario,
                  acessos.HistoricoLaudo
                ) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <HistoricoLaudoContainer altura={props.altura} />
                  </Col>
                )}
              {props.visibilidadeMultiplosExame &&
                props.acessoPermitido(
                  props.usuario,
                  acessos.MultiplosExames
                ) && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <MultiplosExamesContainer
                      altura={props.altura}
                      laudo={props.detalhes.laudo}
                    />
                  </Col>
                )}
              <Col
                style={{
                  paddingLeft: '0px',
                  minWidth: '70%',
                  maxWidth: '100%',
                }}
              >
                <div
                  id="container-editor-etapa"
                  style={{ height: '100%' }}
                ></div>
              </Col>
            </Row>
            <ButtonFloating actions={props.getActionsButtons} />
          </div>
        </div>
      )}
    </Col>
  </div>
);

export default MacroscopiaPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/macroscopia.page.js